<div class="login-container border">
  <form>
    <div class="p-5 bg-light rounded-3">
      <div class="container-fluid py-5">
        <h1 class="display-5 fw-bold mb-0">
          LDS Hub
        </h1>
        <h5 class="mb-0" [ngClass]="Prod ? 'text-danger' : 'text-info'">{{ Prod ? 'Production' : 'Test'}}</h5>
        <hr>
        <p class="text-danger">System contains sensitive information!</p>
        <h3 *ngIf="!authError && !authEmpty">Validating permissions. Please wait...</h3>
        <h3 *ngIf="authError && !authEmpty">
          Something went wrong, please try again
          <hr>
          <a class="btn btn-block btn-lg btn-outline-primary" routerLink="/openid" routerLinkActive="active">Retry</a>
        </h3>
        <h3 *ngIf="authEmpty" class="text-center">
          <a class="btn btn-block btn-lg btn-outline-primary" routerLink="/openid" routerLinkActive="active">Go to
            GEMS ID</a>
        </h3>
      </div>
    </div>

  </form>
</div>
